import React from 'react'
import classnames from 'classnames'

const SportBadges = props => {
    const {
        sports,
        noDelete,
    } = props

    return (
        <div className="d-flex flex-row flex-wrap">
            {sports && sports.map(sport => (
                <div
                    className={classnames({
                        'sport-badges__badge px-1 py-1 mx-2 my-2': true,
                        'pr-3': noDelete,
                    })}
                    key={sport.value || sport.id}
                >
                    <img
                        src={sport.imagePath || sport.image_path || sport?.sport?.data?.image_path || '/images/default-sport.png'}
                        className="mx-2 sport-badges__badge--icon"
                        alt=""
                    />
                    {sport.label || sport.name || sport?.sport?.data?.name}
                    {!noDelete &&
                        <i
                            className="fa fa-times p-2"
                            onClick={() => props.clicked(sport)}
                        />
                    }
                </div>
            ))}
        </div>
    )
}

export default SportBadges
